// src/routes/publicRoutes.js

import React from "react";
import SignUp from "../pages/auth/SignUp";
import SignIn from "../pages/auth/SignIn";
import SigninOTP from "../pages/auth/SigninOTP";
import SignupOTP from "../pages/auth/SignupOTP";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ForgotPasswordOTP from "../pages/auth/ForgotPasswordOTP";
import NewPassword from "../pages/auth/NewPassword";
import NotFound from "../pages/404";

export const publicRoutes = [
  { path: "/", element: <SignIn /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/signin", element: <SignIn /> },
  { path: "/signin/otp", element: <SigninOTP /> },
  { path: "/signup/otp", element: <SignupOTP /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/forgot-password/otp", element: <ForgotPasswordOTP /> },
  { path: "/reset-password", element: <NewPassword /> },

  { path: "*", element: <NotFound /> }
]; 